import styled from 'styled-components';

export const Container = styled.div`
  animation: rendering 1s;
  width: 100%;

  transition: all 1s;
  min-height: 435px;

  background: repeating-linear-gradient(
    -55deg,
    rgba(255, 255, 255, 0.1),
    rgba(255, 255, 255, 0.1) 1px,
    var(--light-bg) 1px,
    var(--light-bg) 15px
  );

  @media (max-width: 420px) {
    min-height: 360px;
  }
  @media (max-width: 380px) {
    min-height: 332px;
  }

  > div {
    display: flex;
    flex-direction: column;
    margin: 0px auto;
    padding-top: 40px;
    padding-bottom: 40px;

    @keyframes rendering {
      from {
        transform: scale(0);
        opacity: 0;
      }
      to {
        transform: scale(1);
        opacity: 1;
      }
    }

    > div.slick-slider {
      animation: rendering 1s ease-in;
      transition: all 1s;
      width: 100%;
    }
  }
`;

export const Spinner = styled.div`
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  border: 8px solid rgba(0, 0, 0, 0.1);
  border-left-color: var(--blue2c);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1.2s linear infinite;
  margin: 0 auto;
`;

export const Title = styled.div`
  font-family: 'Montserrat';
  font-size: 1.6rem;
  color: #000;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  margin: 20px 0px;
`;

export const ExclusiveContent = styled.div`
  width: 280px;
  display: flex;
  justify-content: center;
  border-radius: var(--border20);
  font-family: 'Montserrat';
  font-size: 1.4rem;
  color: #fff;
  padding: 4px;
  margin-left: 10px;

  background: linear-gradient(90deg, var(--purple6a) 0%, var(--purple84) 50%);
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;

  padding-left: 10px;

  > div:nth-of-type(1) {
    font-family: 'Montserrat';
    font-size: 2.4rem;
    color: #000000;
  }

  > div:nth-of-type(2) {
    font-family: 'Montserrat';
    font-size: 2.8rem;
    color: var(--green24);
    margin: 10px 0px 10px 20px;
  }
`;
